export default "__VITE_ASSET__gEaRUdAN__"